import { createConnection } from "./utils/ConnectionFactory.js";
import { applyDelay } from "./utils/applyDelay.js";
import { BaseConversation } from "./BaseConversation.js";
const EMPTY_FREQUENCY_DATA = new Uint8Array(0);
export class TextConversation extends BaseConversation {
    type = "text";
    setVolume() {
        throw new Error("setVolume is not supported in text conversations");
    }
    setMicMuted() {
        throw new Error("setMicMuted is not supported in text conversations");
    }
    getInputByteFrequencyData() {
        return EMPTY_FREQUENCY_DATA;
    }
    getOutputByteFrequencyData() {
        return EMPTY_FREQUENCY_DATA;
    }
    getInputVolume() {
        return 0;
    }
    getOutputVolume() {
        return 0;
    }
    static async startSession(options) {
        const fullOptions = BaseConversation.getFullOptions(options);
        if (fullOptions.onStatusChange) {
            fullOptions.onStatusChange({ status: "connecting" });
        }
        if (fullOptions.onCanSendFeedbackChange) {
            fullOptions.onCanSendFeedbackChange({ canSendFeedback: false });
        }
        if (fullOptions.onModeChange) {
            fullOptions.onModeChange({ mode: "listening" });
        }
        if (fullOptions.onCanSendFeedbackChange) {
            fullOptions.onCanSendFeedbackChange({ canSendFeedback: false });
        }
        let connection = null;
        let conversation = null;
        try {
            await applyDelay(fullOptions.connectionDelay);
            connection = await createConnection(fullOptions);
            conversation = new TextConversation(fullOptions, connection);
            fullOptions.onConversationCreated?.(conversation);
            conversation.markConnected();
            fullOptions.onConnect?.({ conversationId: connection.conversationId });
            return conversation;
        }
        catch (error) {
            if (conversation) {
                await conversation.endSession().catch(() => { });
            }
            else {
                fullOptions.onStatusChange?.({ status: "disconnected" });
                connection?.close();
            }
            throw error;
        }
    }
}
//# sourceMappingURL=TextConversation.js.map